import React, { PropsWithChildren } from 'react';
import Link from 'next/link';
import { RichText } from '../RichText';
import { Logo } from '@/components/visuals';

export const Page: React.FC<PropsWithChildren<{}>> = ({ children }) => (
  <RichText className="container py-6">
    <Link href="/">
      <Logo className="block w-12 h-auto mx-auto mb-9 fill-brand-default-500" />
    </Link>
    {children}
  </RichText>
);
